import React, { useState } from 'react';
import {
  Container,
  Typography,
  Paper,
  TextField,
  Button,
  Box,
  Alert,
  Grid,
} from '@mui/material';
import Layout from '../../components/Layout';
import api from '../../services/api';
import { useLocation, useNavigate } from 'react-router-dom';

const CustomerPayments = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const invoice = location.state?.invoice;
  
  const [formData, setFormData] = useState({
    card_number: '',
    expiry_month: '',
    expiry_year: '',
    cvv: '',
    cardholder_name: '',
    amount: invoice?.total_amount || '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await api.post('/payments/process/', {
        invoice_id: invoice.id,
        amount: formData.amount,
        card_data: {
          card_number: formData.card_number,
          expiry_month: formData.expiry_month,
          expiry_year: formData.expiry_year,
          cvv: formData.cvv,
          cardholder_name: formData.cardholder_name,
        },
      });

      if (response.data.message) {
        setSuccess(true);
        setTimeout(() => {
          navigate('/customer/invoices');
        }, 2000);
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Payment failed');
    } finally {
      setLoading(false);
    }
  };

  if (!invoice) {
    return (
      <Layout>
        <Container>
          <Alert severity="error">No invoice selected</Alert>
        </Container>
      </Layout>
    );
  }

  return (
    <Layout>
      <Container>
        <Typography variant="h4" gutterBottom>
          Make Payment
        </Typography>
        <Paper sx={{ p: 3, mt: 3 }}>
          <Box mb={3}>
            <Typography variant="h6">Invoice Details</Typography>
            <Typography>Invoice Number: {invoice.invoice_number}</Typography>
            <Typography>Amount: ${invoice.total_amount}</Typography>
          </Box>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          {success && (
            <Alert severity="success" sx={{ mb: 2 }}>
              Payment processed successfully!
            </Alert>
          )}
          <Box component="form" onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Card Number"
                  name="card_number"
                  value={formData.card_number}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Expiry Month"
                  name="expiry_month"
                  value={formData.expiry_month}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="Expiry Year"
                  name="expiry_year"
                  value={formData.expiry_year}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  label="CVV"
                  name="cvv"
                  value={formData.cvv}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Cardholder Name"
                  name="cardholder_name"
                  value={formData.cardholder_name}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Amount"
                  name="amount"
                  type="number"
                  value={formData.amount}
                  onChange={handleChange}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  disabled={loading || success}
                >
                  {loading ? 'Processing...' : 'Process Payment'}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </Container>
    </Layout>
  );
};

export default CustomerPayments;



